export default __webpack_public_path__ + "static/logo-691d9094871a3205138406956c2bc552.png";